import { jsx as _jsx } from "react/jsx-runtime";
// styles
import { TextCounterStyled } from '../input.styled';
export const TextCountStandAlone = ({ styles, ...props }) => {
    if (!props.textCounter) {
        return null;
    }
    return _jsx(TextCounterStyled, { styles: styles, children: props.textCounter });
};
//# sourceMappingURL=textCounter.js.map